import { UseTellescopeQueryOptions } from "../../types";
import { useTellescopeQuery } from "../../use-tellescope-query";

// TODO: consider using fhir package: https://www.npmjs.com/package/@types/fhir
export const FDB_CODING_SYSTEM = "fdbhealth";

export interface FHIRCoding {
  system: string;
  code: string;
  display: string;
}

export interface FHIRMedication {
  resourceType: string;
  id: string;
  code?: {
    coding?: FHIRCoding[];
  };
}

export interface CanvasMedicationsBundle {
  resourceType: "Bundle";
  type: "searchset";
  total: number;
  link?: {
    relation: string;
    url: string;
  }[];
  entry?: {
    resource: FHIRMedication;
  }[];
}

export interface CanvasMedicationOption {
  code: string;
  display: string;
}

export const canvasMedicationOptions = (bundle: CanvasMedicationsBundle | undefined): CanvasMedicationOption[] =>
  (bundle?.entry ?? []).reduce<CanvasMedicationOption[]>(
    (options, entry) =>
      (entry?.resource?.code?.coding ?? []).reduce(
        (acc, coding) =>
          coding.system?.includes(FDB_CODING_SYSTEM) ? [...acc, { code: coding.code, display: coding.display }] : acc,
        options
      ),
    []
  );

export interface UseCanvasMedicationsQueryOptions<TError = Error, TData = { data: CanvasMedicationsBundle }>
  extends Omit<UseTellescopeQueryOptions<"integrations", "proxy_read", TError, TData>, "model" | "method" | "request"> {
  query: string | undefined;
}

export const useCanvasMedicationsQuery = <TError = Error, TData = { data: CanvasMedicationsBundle }>({
  query,
  enabled,
  ...options
}: UseCanvasMedicationsQueryOptions<TError, TData>) =>
  useTellescopeQuery({
    model: "integrations",
    method: "proxy_read",
    request: { integration: "Canvas", type: "medications", query: query ?? "" },
    enabled: !!query && (enabled ?? true),
    ...options,
  });
